export default "__VITE_ASSET__CJyPKaIK__"